import { createFileRoute } from "@tanstack/react-router";
import {
    applicationFlowRoute,
    ApplicationRoute,
    ApplicationRouteError,
} from "@/app-clients/application-flow";

export const Route = createFileRoute("/application/$token")({
    loader: applicationFlowRoute.loader,
    head: applicationFlowRoute.head,
    component: ApplicationRoute,
    errorComponent: ApplicationRouteError,
});
